(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[337],{

/***/ 9993:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work",
      function () {
        return __webpack_require__(3817);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var ImageWithTransition = function(param) {
    var src = param.src, layout = param.layout, sizes = param.sizes, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, classes = param.classes, objectFit = param.objectFit, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var onLoadingComplete = function() {
        return setIsLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        className: "".concat(classes, " transition-all duration-500 ").concat(isLoading ? "opacity-0" : "opacity-100"),
        src: src,
        layout: layout,
        onLoadingComplete: onLoadingComplete,
        objectFit: objectFit,
        priority: priority,
        quality: quality,
        loading: loading,
        alt: alt,
        sizes: sizes
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWithTransition);


/***/ }),

/***/ 6980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ NewsCard; },
  "t": function() { return /* binding */ ProjectCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(7005);
// EXTERNAL MODULE: ./components/Elements/ImageWithTransition.js
var ImageWithTransition = __webpack_require__(2142);
// EXTERNAL MODULE: ./node_modules/bowser/es5.js
var es5 = __webpack_require__(1206);
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);
;// CONCATENATED MODULE: ./components/Elements/VideoLazy.js



function VideoLazy(param) {
    var videoDesktop = param.videoDesktop, videoMobile = param.videoMobile;
    var ref = (0,react.useState)(null), platform = ref[0], setPlatform = ref[1];
    (0,react.useEffect)(function() {
        var browser = es5_default().getParser(window.navigator.userAgent);
        setPlatform(browser.getPlatform().type);
    }, []);
    (0,react.useEffect)(function() {
        var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
        if ("IntersectionObserver" in window) {
            var lazyVideoObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(video) {
                    if (video.isIntersecting) {
                        for(var source in video.target.children){
                            var videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }
                        video.target.load();
                        video.target.classList.remove("lazy");
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });
            lazyVideos.forEach(function(lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        preload: "metadata",
        className: "lazy object-center h-full w-full object-cover",
        autoPlay: true,
        muted: true,
        playsInline: true,
        loop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            "data-src": platform === "desktop" ? videoDesktop : videoMobile,
            type: "video/mp4"
        })
    });
}

;// CONCATENATED MODULE: ./components/GridCards/index.js






var ProjectCard = function(props) {
    var ref = (0,react.useState)(false), isShown = ref[0], setIsShown = ref[1];
    return props.outsideURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: props.outsideURL,
            className: "group",
            onMouseEnter: function() {
                return setIsShown(true);
            },
            onMouseLeave: function() {
                return setIsShown(false);
            },
            target: "_blank",
            rel: "noreferrer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative image-container aspect-video",
                    children: [
                        props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                            videoDesktop: props.videoDesktop,
                            videoMobile: props.videoMobile
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                            src: props.imageUrl,
                            objectFit: "cover",
                            layout: "fill",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-0 card-overlay ease-easeInOutQuint group-hover:opacity-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute top-0 left-0 w-full h-full overlay-bg bg-black/40"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    gradient: false,
                                    play: isShown,
                                    speed: 80,
                                    direction: props.index % 2 == 0 ? "left" : "right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-white uppercase",
                                        children: [
                                            props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            }),
                                            props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between gap-x-[20px] mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props.title
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                props.client ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.client
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }),
                        props.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.year
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fluid-type-mini flex items-center ml-auto h-[28px] w-[56px] min-w-[56px] 768:h-[32px] 768:w-[70px] 768:min-w-[70px] whitespace-nowrap rounded-[50%] bg-black border-black border-[3px] text-white uppercase overflow-hidden mb-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "btn-ticker-inner-v3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-text": "News",
                                        children: "News"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            scroll: false,
            href: props.projectLink,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "group",
                onMouseEnter: function() {
                    return setIsShown(true);
                },
                onMouseLeave: function() {
                    return setIsShown(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative image-container aspect-video",
                        children: [
                            props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                                videoDesktop: props.videoDesktop,
                                videoMobile: props.videoMobile
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                                src: props.imageUrl,
                                objectFit: "cover",
                                layout: "fill",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-0 card-overlay ease-easeInOutQuint group-hover:opacity-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-full overlay-bg bg-black/40"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        gradient: false,
                                        play: isShown,
                                        speed: 80,
                                        direction: props.index % 2 == 0 ? "left" : "right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-white uppercase",
                                            children: [
                                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                }),
                                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-12 gap-0 mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-8 991:col-span-10",
                                children: [
                                    props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: props.title
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    props.client ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.client
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }),
                            props.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-4 991:col-span-2 text-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.year
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            })
        })
    });
};
var NewsCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-container",
                children: props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                    videoDesktop: props.videoDesktop,
                    videoMobile: props.videoMobile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                    src: props.imageUrl,
                    layout: "fill",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: props.title
                })
            })
        ]
    });
};


/***/ }),

/***/ 3817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ work; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(2951);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/GridCards/index.js + 1 modules
var GridCards = __webpack_require__(6980);
// EXTERNAL MODULE: ./components/MetaTags/index.js
var MetaTags = __webpack_require__(8992);
// EXTERNAL MODULE: ./components/Elements/AnimatedBox.js + 3 modules
var AnimatedBox = __webpack_require__(7603);
// EXTERNAL MODULE: ./strapi/api.js + 4 modules
var api = __webpack_require__(1014);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(4441);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 98 modules
var motion = __webpack_require__(6673);
;// CONCATENATED MODULE: ./pages/work/index.js












var index = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(index, _Component);
    var _super = _createSuper(index);
    function index(props) {
        (0,_class_call_check/* default */.Z)(this, index);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            filters: Number(props.filters)
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(index, [
        {
            key: "generateDelay",
            value: function generateDelay() {
                return Math.floor(Math.random() * 6) + 1;
            }
        },
        {
            key: "handleFilterChange",
            value: function handleFilterChange(value) {
                var currentFilters;
                if (this.state.filters == value.target.value) {
                    currentFilters = "";
                } else {
                    currentFilters = value.target.value;
                }
                this.setState(function(prevState) {
                    return {
                        filters: Number(currentFilters)
                    };
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                            title: "WORK",
                            description: "All ZANAD Projects",
                            image: "/og-image.jpg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "offscreen-title",
                                    children: "Projects"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full min-h-screen px-2 pt-20 mx-auto 768:px-5 768:pt-56",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap",
                                            children: this.props.categories && this.props.categories.map(function(category, i) {
                                                var delay = _this.generateDelay();
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            hidden: true,
                                                            id: i,
                                                            type: "radio",
                                                            name: "filter",
                                                            checked: _this.state.filters === category.id ? "checked" : "",
                                                            value: category.id,
                                                            className: "peer",
                                                            onChange: function(e) {
                                                                _this.handleFilterChange({
                                                                    target: {
                                                                        name: e.target.name,
                                                                        value: e.target.value,
                                                                        checked: e.target.defaultChecked
                                                                    }
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: i,
                                                            className: "cursor-pointer uppercase fluid-type leading-none relative animated-border inline-block dark-border peer-checked optical-align letter-".concat(category.attributes.title.charAt(0)),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedBox/* default */.Z, {
                                                                num: delay,
                                                                children: category.attributes.title
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-20 640:text-30 block mx-2 991:ml-2 991:mr-5 text-[#8f8f8f]",
                                                            children: category.attributes.works.data && category.attributes.works.data.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedBox/* default */.Z, {
                                                                num: delay,
                                                                children: category.attributes.works.data.length
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "mt-8 mb-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                                initial: "false",
                                                exitBeforeEnter: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                                    className: "grid grid-cols-2 640:grid-cols-12 gap-x-5 gap-y-2 768:gap-y-8",
                                                    exit: {
                                                        opacity: 0
                                                    },
                                                    initial: {
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        opacity: 1
                                                    },
                                                    transition: {
                                                        duration: 0.3,
                                                        ease: [
                                                            0.19,
                                                            1,
                                                            0.22,
                                                            1
                                                        ]
                                                    },
                                                    children: this.props.projects.length && this.props.projects.filter(function(project) {
                                                        return _this.state.filters ? project.work_category.data.map(function(category) {
                                                            return category.id;
                                                        }).includes(_this.state.filters) : true;
                                                    }).map(function(project, i) {
                                                        return project.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-span-2 640:col-span-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridCards/* ProjectCard */.t, {
                                                                projectLink: "/work/" + project.slug,
                                                                imageUrl: api/* default.getNextOriginalImage */.Z.getNextOriginalImage(project.thumbnail.data.attributes.url),
                                                                title: project.title,
                                                                client: project.client,
                                                                year: project.year,
                                                                index: i
                                                            })
                                                        }, i);
                                                    })
                                                }, this.state.filters)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return index;
}(react.Component);
var __N_SSG = true;
/* harmony default export */ var work = ((0,router.withRouter)(index));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,84,774,888,179], function() { return __webpack_exec__(9993); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);